/*
 * @Author: wolfsheller
 * @Description: 用来全局管理
 * @Date: 2018-07-19 17:22:26
 * @Last Modified by: hongmeiting
 * @Last Modified time: 2020-01-07 14:32:12
 */
const app = {
  state: {
    globalLoading: false,
    language: '',
    manageLoginInfo: []
  },
  mutations: {
    // 设置收银全局loading
    SET_GLOBAL_LOADING: (state, loading) => {
      state.globalLoading = loading
    },
    SET_LANGUAGE_CHANGE: (state, val) => {
      state.language = val
    },
    SET_MANAGE_LOGIN_INFO: (state, val) => {
      state.manageLoginInfo = val
    }
  }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js